import { Container, Grid, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import ForgetPasswordImage from "../../../../../styles/img/forgot-password-image.png";
import { CloseIcon } from "../../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { UiPopup } from "../../../../_uiComponents/common/UiModal";
import { SuccussIcon } from "../../../../../styles/img/svg/SuccussIcon";
import { SuccessMessagePopup } from "../../../../_uiComponents/Popups/SuccessMessagePopup";
import { UiTab } from "../../../../_uiComponents/common/UiTab";
import { TabPanel } from "@mui/lab";
import { ForgetPasswordDebitCardForm } from "./ForgetPasswordDebitCardForm";
import { BackIcon } from "../../../../../styles/img/svg/BackIcon";
import { ForgetPasswordCreditCardForm } from "../ForgotPassword/UiForgetPasswordCreditCardForm";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { keyGenerationFun } from "../../../../../_helpers/support.services";
import {
  setForgotPasswordFormData,
  setForgotPasswordScreenType,
  setTabType,
} from "../../../../../_redux/_actions";
import {
  authConstants,
  commonConstants,
} from "../../../../../_redux/_constants";
import { ForgotUserNameLeavePopup } from "../../../ForgotUsername/popups/forgotUserNameLeavePopup";
import { ConfirmationIcon } from "../../../../../styles/img/svg/ConfirmationIcon";
import { UiNavTab } from "../../../../_uiComponents/common/UiNavTab";
import { UiDebitCreditCard } from "../../../../_uiComponents/Auth/UiDebitCreditCard";
import VisaLogo from "../../../../../styles/img/visa-logo.png";
import MasterLogo from "../../../../../styles/img/master-logo.png";
import VisaCreditLogo from "../../../../../styles/img/visacredit-img.png";
import { ForgetPasswordAccountDetailsForm } from "../../Forms/ForgetPasswordAccountDetailsForm";

export const PwResetEnterAccountDetails = (props) => {
  const [displayName, setDisplayName] = useState("");
  const [showActionButtons, setShowActionButtons] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);
  const [cardTypeLogo, setCardTypeLogo] = useState(null);
  const [formDirty, setFormDirty] = useState(false);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const actionDispatch = useDispatch();
  const tabType = useSelector((state) => state.auth.tabType);
  const { keyGeneration } = useSelector((state) => {
    return {
      keyGeneration: state.keyGeneration,
    };
  });

  const forgotFormData = useSelector((state) => state.auth.forgotFormData);

  useEffect(() => {
    const fetchData = async () => {
      if (keyGeneration.regenerateKey) {
        await keyGenerationFun(actionDispatch, true);
      }
    };

    fetchData();
  }, [keyGeneration.regenerateKey]);

  const backtoHome = () => {
    setShowLeavingPopup(true);
  };

  const okBtnHandler = () => {
    navigate("/");
  };

  const backtoResetUsername = () => {
    actionDispatch({ type: authConstants.RESET_OTP_CONFIRM_STATE });
    const {
      bankAccountNo,
      dateOfBirth,
      registeredType,
      ...remainingData
    } = forgotFormData || {};

    actionDispatch(setForgotPasswordFormData(remainingData));

    actionDispatch(
      setForgotPasswordScreenType(
        commonConstants.FORGOT_PASSWORD_TAB_LIST_SCREEN,
      ),
    );
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box df-onboard-nic-begin-tab">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={backtoHome}>
            <CloseIcon />
          </div>

          <div
            className="df-user-profile__back-icon"
            onClick={backtoResetUsername}
          >
            <BackIcon />
          </div>

          <div className="df-user-profile__body  df-pw-tab ">
            <Grid container>
              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center"
              >
                <h2 className="df-reset-pw-title">
                  {t("Let's verify your account details")}
                </h2>

                <img
                  src={ForgetPasswordImage}
                  className="df-reset-pw-img df-forgot-pw-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <ForgetPasswordAccountDetailsForm
                  onDirtyChange={setFormDirty}
                />
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <UiPopup
        openModal={openModal}
        handleClose={handleCloseModal}
        showCloseIcon
      >
        <SuccessMessagePopup
          icon={<SuccussIcon />}
          message={t("Profile updated successfully!")}
          buttonText={t("Ok")}
          buttonOnClick={handleCloseModal}
        />
      </UiPopup>

      <UiPopup
        openModal={showLeavingPopup}
        handleClose={() => {
          setShowLeavingPopup(false);
        }}
      >
        <ForgotUserNameLeavePopup
          icon={<ConfirmationIcon />}
          message={t("Leaving this page?")}
          buttonText={t("Leave")}
          buttonOnClickClose={() => {
            setShowLeavingPopup(false);
          }}
          buttonOnClick={okBtnHandler}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            {t(
              "Are you sure you want to leave this page? You have some unsaved changes.",
            )}
          </p>
        </ForgotUserNameLeavePopup>
      </UiPopup>
    </>
  );
};
